/** @jsxImportSource @emotion/react */
import React from 'react';
import { Alert, Form, Select } from 'antd';
import type { RotationCheckResult } from '../../../../../api/fieldsApi';

interface Crop {
  id: number | string;
  name: string;
  latinName?: string | null;
}

interface CropSectionProps {
  crops: Crop[];
  cropsLoading: boolean;
  rotationCheck: RotationCheckResult | null;
  onCropChange: (cropId: string | undefined) => void;
}

/** Crop selection dropdown + rotation check alert */
const CropSection: React.FC<CropSectionProps> = ({
  crops,
  cropsLoading,
  rotationCheck,
  onCropChange,
}) => (
  <>
    <Form.Item
      label="Культура"
      name="cropId"
      rules={[{ required: true, message: 'Выберите культуру' }]}
    >
      <Select
        placeholder="Выберите культуру"
        loading={cropsLoading}
        showSearch
        optionFilterProp="label"
        options={crops.map((crop) => ({
          value: crop.id,
          label: crop.latinName ? `${crop.name} (${crop.latinName})` : crop.name,
        }))}
        onChange={(cropId) => onCropChange(cropId ? String(cropId) : undefined)}
      />
    </Form.Item>

    {rotationCheck && rotationCheck.severity !== 'none' && (
      <Alert
        type={rotationCheck.severity === 'severe' ? 'error' : 'warning'}
        showIcon
        style={{ marginBottom: 16 }}
        message={
          rotationCheck.severity === 'severe'
            ? `Сильное утомление почвы для ${rotationCheck.familyRu}`
            : `Возможное утомление почвы для ${rotationCheck.familyRu}`
        }
        description={
          <>
            <div>Потеря урожая: ~{rotationCheck.penaltyPct}%</div>
            {rotationCheck.reasons.map((r, i) => (
              <div key={i} style={{ fontSize: 12, color: '#666' }}>
                • {r.label}
              </div>
            ))}
            {rotationCheck.recommendation && (
              <div style={{ marginTop: 4 }}>{rotationCheck.recommendation}</div>
            )}
          </>
        }
      />
    )}
  </>
);

export default CropSection;
